// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__11jSd","footer":"ModalInfo_footer__3HJZq"};